import { useEffect, useRef } from 'react';

export const useRefetchHook = (
  callback: () => void,
  isGenerating: boolean,
  isFetching: boolean,
  intervalMs = 20000,
) => {
  const savedCallback = useRef(callback);

  // Mantiene la referencia actualizada del callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (isGenerating && !isFetching) {
      const interval = setInterval(() => {
        savedCallback.current();
      }, intervalMs);

      return () => clearInterval(interval);
    }
  }, [isGenerating, isFetching, intervalMs]);
};
